import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertCircle } from "lucide-react";
import { capi, apiError } from "@/lib/api";
import { AuthCard } from "@/components/account/AuthCard";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const [msg, setMsg] = useState("");
  const [claimed, setClaimed] = useState(0);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); setMsg("This verification link is missing its token."); return; }
    capi.post("/account/verify-email", { token })
      .then(({ data }) => { setClaimed(data.claimed_requests || 0); setState("ok"); })
      .catch((e) => { setMsg(apiError(e)); setState("error"); });
  }, [params]);

  return (
    <AuthCard title="Email verification" testid="verify-email-page">
      {state === "checking" && <div className="flex items-center gap-3 text-sm text-kys-charcoal"><Loader2 className="h-5 w-5 animate-spin text-kys-accent" /> Verifying…</div>}
      {state === "ok" && (
        <div data-testid="verify-success">
          <CheckCircle2 className="h-10 w-10 text-kys-accent" />
          <p className="mt-4 text-sm text-kys-charcoal">Your email is verified and your account is active.</p>
          {claimed > 0 && <p className="mt-2 text-sm text-kys-charcoal">We found {claimed} custom request{claimed === 1 ? "" : "s"} sent with this email and added {claimed === 1 ? "it" : "them"} to your account.</p>}
          <Link to="/account/login" data-testid="verify-signin-link" className="mt-6 inline-flex rounded-full bg-kys-ink px-6 py-3 text-sm font-semibold text-white hover:bg-kys-accent">Sign in</Link>
        </div>
      )}
      {state === "error" && (
        <div data-testid="verify-error">
          <AlertCircle className="h-10 w-10 text-destructive" />
          <p className="mt-4 text-sm text-kys-charcoal">{msg}</p>
          <Link to="/account/login" className="mt-6 inline-flex text-sm font-semibold text-kys-accent hover:underline">Sign in to request a new link →</Link>
        </div>
      )}
    </AuthCard>
  );
}
